
import Redirect from './Redirect';
import './App.css';

function App() {
  return <Redirect />;
}

export default App;
